import { motion } from "framer-motion";

export const SectionHead = ({ eyebrow, title, center = false, testId }) => (
    <div className={center ? "text-center" : ""}>
        <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-mono2 text-xs sm:text-sm uppercase tracking-[0.25em] text-lakou-gold font-semibold mb-5"
        >
            {eyebrow}
        </motion.p>
        <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.08 }}
            data-testid={testId}
            className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-lakou-cream leading-[1.05]"
        >
            {title}
        </motion.h2>
    </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);
